import React from 'react';
import './order.scss';
import { Iprops } from './orderinterface';
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import Loader from '../../Loader';
import helperfunctions from '../../../utils/helperfunctions';
import { DataTable } from '../../CommonComponent';

const PriceView = (row: any) => {
    const { t } = useTranslation();
    return (<td>{helperfunctions.getUnitPrice(row?.dataItem?.price, t, row?.dataItem?.isContactDealer)}</td>);
}

const PromoPriceView = (row: any) => {
    return (<td>${helperfunctions.formatAmount(row?.dataItem?.promoPrice)}</td>);
}

const Order = (props: Iprops) => {
    const { t } = useTranslation();
    const { orderSummaryData } = props;
    const { shippingInfo, shippingMethod, payment, pickupInfo, fullFillment, total, isPromoCodeApplied, fullFillmentSummary } = orderSummaryData?.data ?? {};
    const { shippingAddress, contact } = shippingInfo ?? {};
    const { pickupAddress } = pickupInfo ?? {};
    const { order, shipment  } = props?.stepperDetails ?? {};
    const { isShippingType, isPickupType } = shipment ?? {};
    const isShowWeatherWarning = (shipment?.weatherWarning?.warning);
    const shippingMethodName = shippingMethod?.name?.toLowerCase();
    const isDeliveryOrDropbox = shippingMethodName == "delivery" || shippingMethodName == "dropbox" || shippingMethodName == "freight truck";
    const getFieldValue = (fieldValue: any) => {
        return fieldValue ?? '';
    }

    const getColumns = () => {
        let columns = [
            {
                field: "partNumber",
                title: t(RESOURCE.MyK_Grid_Part_Number),
                sortable: false,
                width: 120,

            },
            {
                field: "partDescription",
                title: t(RESOURCE.MyK_Grid_Part_Name),
                sortable: false,
            },
            {
                field: "quantity",
                title: t(RESOURCE.MyK_Grid_Quantity),
                sortable: false,
                width: 100
            },
            {
                field: "price",
                title: t(RESOURCE.MyK_Grid_Price),
                sortable: false,
                style: { textAlign: 'right' },
                width: 180,
                cell: PriceView
            }
        ]
        if (isPromoCodeApplied) {
            columns.push({
                field: "promoPrice",
                title: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Price),
                sortable: false,
                style: { textAlign: 'right' },
                width: 120,
                cell: PromoPriceView
            });
        }

        return columns;
    }

    const getContacDealerTotal = (fullfilmenttype: any, total: any) => {
        if (fullfilmenttype?.toLowerCase() == 'contactdealer' && total == 0) {
            return "N/A";
        }
        else {
            return `$${helperfunctions.formatAmount(total)}`
        }
    }

    const columns = getColumns();
    return (
        <div className="order_container">
            <div className="order_contents">
                {orderSummaryData?.loading && <span className='orderLoader'><Loader /></span>}
                <div className="custom_header mb-4">
                    <span>{t(RESOURCE.MyK_Label_SC_Spl_Instruction)}</span>
                </div>
                <div className="ordertextarea_wrapper mb-4">
                    <textarea
                        className="textarea"
                        rows={4}
                        value={getFieldValue(order?.splInstruction)}
                        onChange={(e: any) => props?.onSplInstructionChange(e?.target?.value ?? '')}></textarea>
                </div>
                <div className="custom_header mb-4">
                    <span>{t(RESOURCE.MyK_Label_SC_OrderSummary_By_FullfilmentType)}</span>
                    <span className='fa fa-pencil' onClick={() => {
                        props.changeindexone();
                        props.scrollToDiv('fulfillmentDiv');
                    }} onKeyDown={() => { }}></span>
                </div>
                <div className="ordersummary_wrapper mb-4">
                    <div className="esttotal mb-2 px-3 pt-3">
                        <div className="row">
                            <div className="col-8">
                                <span className="totaltext">{t(RESOURCE.MyK_Label_SC_Order_Est_Total)}</span>
                                <div>
                                    <span className="totalsubtext">{t(RESOURCE.MyK_Label_SC_Order_Est_Total_With_Shipping)}</span>
                                </div>
                            </div>
                            <div className="col-4">
                                <span className="totalamount">${helperfunctions.formatAmount(total?.estTotal ?? 0)}</span>
                                <div><span className="totalsubamount">${helperfunctions.formatAmount(total?.estPreTaxWithShipping ?? 0)}</span></div>
                            </div>
                        </div>
                    </div>
                    <div className='ordersummarytable_wrapper'>
                        <div>
                            <p className='subtext mb-3'>{t(RESOURCE.MyK_Label_SC_You_Selected)}: {fullFillment?.type}</p>
                        </div>
                        {fullFillmentSummary?.map((item: any) => (
                            <div key={item?.title}>
                                <div className="orderSummaryTypeTitle mb-2 mt-3">{item?.title}</div>
                                <DataTable
                                storageKey={"orderSummary"} enableFiltering={true}
                                    data={item?.partDetails}
                                    dataColumn={columns}
                                    className={'orderSummaryTable'}
                                    pagination={false}
                                    defaultPageSize={item?.partDetails?.length ?? 0}
                                />
                                <div className='p-2 summaryTotal_wrapper'>
                                    <div className='summaryTotal_content mb-2'>
                                        <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Fullfilment_Total)} </p><p className='amount'>{getContacDealerTotal(item?.fulfillmentType, item?.total?.estTotal ?? 0)}</p>
                                    </div>
                                    {item?.total?.promoCodeWithPrice?.length > 0 &&
                                        <>
                                            <div className='summaryTotal_content mb-2'>
                                            <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Code_Discount)} </p><p className='amount'></p>
                                            </div>
                                            {item?.total?.promoCodeWithPrice?.map((t: any) => (
                                                <div className='summaryTotal_content mb-2' key={t.promoCode}>
                                                    <p className='mr-2 lable'>{t.promoCode} </p><p className='amount'>{getContacDealerTotal(item?.fulfillmentType, t?.totalPrice ?? 0)}</p>
                                                </div>
                                            ))}

                                            <div className='summaryTotal_content mb-2'>
                                            <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Fullfilment_Total_AfterDiscount)} </p><p className='amount'>{getContacDealerTotal(item?.fulfillmentType, item?.total?.estTotalAfterDiscount ?? 0)}</p>
                                            </div>
                                        </>
                                    }
                                    {(item?.showShippingCost && !isDeliveryOrDropbox) && <div className='summaryTotal_content mb-2'>
                                        <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Est_Shipping_Total)}</p><p className='amount'>{getContacDealerTotal(item?.fulfillmentType, item?.total?.estPreTaxWithShipping ?? 0)}</p>
                                    </div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                        <div>
                            <div className={`custom_header ${!isShowWeatherWarning ? 'mb-4' : ''}`}>
                                <span>{t(RESOURCE.MyK_Label_SC_Order_Information)}</span>
                                <span className='fa fa-pencil' onClick={() => {
                                    props.changeindexone();
                                    props.scrollToDiv('pickUpDiv');
                                }} onKeyDown={() => { }}></span>
                            </div>

                        {isShowWeatherWarning && <div className="ErrorMessage_Wrapper">
                            {<div className="ErrorMessage_card">
                                <span className="fa fa-exclamation-circle"></span> <span>{t(RESOURCE.MyK_Label_ShoppingCart_Weather_Warning)}</span>
                            </div>}
                        </div>}

                        {isPickupType && <div className="ordercontent_wrapper mb-4">
                            <div className="row">
                                <div className="col-12 col-md-6 col-xl-10">
                                    <span className="orderSummaryTypeTitle">{t(RESOURCE.MyK_Label_SC_Order_Pickup_Info)}</span>
                                </div>
                            </div>
                            <div className="mb-2">{getFieldValue(pickupAddress?.companyName)}</div>
                            <div className="row">
                                <div className="col-12 col-md-6 col-xl-10">
                                    <span>{getFieldValue(pickupAddress?.address1)}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 col-xl-10">
                                    <span>{getFieldValue(pickupAddress?.address2)}</span>
                                </div>
                            </div>
                            <div className="mb-2">{`${getFieldValue(pickupAddress?.city)}, ${getFieldValue(pickupAddress?.state)}, ${getFieldValue(pickupAddress?.zipCode)}  ${getFieldValue(pickupAddress?.countryName)}`}</div>
                        </div>
                        }

                        {isShippingType &&
                            <div className="ordercontent_wrapper mb-4">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-xl-10">
                                        <span className="orderSummaryTypeTitle">{t(RESOURCE.MyK_Label_SC_Order_Shipping_Info)}</span>
                                    </div>
                                </div>
                                <div className="mb-2">{`${getFieldValue(shippingAddress?.firstName)} ${getFieldValue(shippingAddress?.lastName)}`}</div>
                                <div className="row">
                                    <div className="col-12 col-md-6 col-xl-3">
                                        <span>{getFieldValue(shippingAddress?.address1)}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6 col-xl-3">
                                        <span>{getFieldValue(shippingAddress?.address2)}</span>
                                    </div>
                                </div>
                                <div className="mb-2">{`${getFieldValue(shippingAddress?.city)}, ${getFieldValue(shippingAddress?.state)}, ${getFieldValue(shippingAddress?.zipCode)}  ${getFieldValue(shippingAddress?.countryName)}`}</div>
                                <div className="mb-2">{shippingAddress?.phoneCountryCode} {shippingAddress?.phone} </div>
                            </div>
                        }

                        </div>

                    {isPickupType && 
                        <>
                    <div className="custom_header mb-4">
                        <span>{t(RESOURCE.MyK_Label_SC_Contact)}</span>
                        <span className='fa fa-pencil' onClick={() => {
                            props.changeindexone();
                            props.scrollToDiv('orderContactDiv');
                        }} onKeyDown={() => { }}></span>
                    </div>
                    
                    <div className="ordercontent_wrapper mb-4">
                            <div className="mb-2">{contact?.phoneCountryCode} {contact?.phone}</div>
                        <div>{contact?.name}</div>
                        </div>
                    </>
                    }
                    {isShippingType &&
                        <div>
                            <div className={`custom_header mb-4`}>
                                <span>{t(RESOURCE.MyK_Label_SC_Shipping_Method)}</span>
                                <span className='fa fa-pencil' onClick={() => {
                                    props.changeindexone();
                                    props.scrollToDiv('shippingMethodDiv');
                                }} onKeyDown={() => { }}></span>
                            </div>
                          
                            <div className={`ordercontent_wrapper mb-4`}>
                                <div className="mb-2">{shippingMethod?.name}</div>
                                <div>
                                    {!isDeliveryOrDropbox && <>
                                        <span className="mr-3">{t(RESOURCE.MyK_Label_SC_Est_Shipping_Cost)}</span>
                                        <span>${helperfunctions.formatAmount(shippingMethod?.estcost ? Number(shippingMethod?.estcost) : 0)}
                                        </span>
                                    </>}
                                </div>
                            </div>
                        </div>
                    }
                    <div className='custom_header mb-4'>
                        <span>{t(RESOURCE.MyK_Label_SC_Payment)}</span>
                        <span className='fa fa-pencil' onClick={() => {
                            props.changeindextwo();
                            props.scrollToDiv('paymentDiv');
                        }} onKeyDown={() => { }}></span>
                    </div>
                    {(payment?.method && payment?.method.toLowerCase() === "kc") && <div className="ordercontent_wrapper mb-4">
                        <div className="mb-2">{payment?.creditcard?.cardType}</div>
                        <div className="mb-1">
                            <span>{payment?.creditcard?.nameOnCard}</span>
                        </div>
                        <div className="mb-1">
                            <span className="cardnumber">{payment?.creditcard?.cardNumber}</span>
                        </div>
                    </div>}
                    {(payment?.method && payment?.method.toLowerCase() === "ac") &&
                        <div className="ordercontent_wrapper mb-4">
                            <div className="mb-2">{t(RESOURCE.MyK_Label_SC_Open_Account)}</div>
                            <span className="cardnumber">{payment?.openAccount?.poNumber}</span>
                        </div>}
                    {(payment?.method && payment?.method.toLowerCase() === "co") &&
                        <div className="ordercontent_wrapper mb-4">
                            <div className="mb-2">{t(RESOURCE.MyK_Label_SC_Cash_On_Delivery)}</div>
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default Order